'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _players = require('../../store/actions/players');

var iconName = 'next';
var dataHudlElement = 'vi-controls-nextitem';
var title = 'vi.player.controls.next';

var mapStateToProps = function mapStateToProps(state, ownProps, _ref) {
  var playerId = _ref.playerId;
  var _state$players$player = state.players[playerId],
      playables = _state$players$player.playables,
      playingIndex = _state$players$player.playingIndex;


  return {
    dataHudlElement: dataHudlElement,
    isHidden: ownProps.isHidden !== undefined ? ownProps.isHidden : playables.size <= 1,
    isInactive: ownProps.isInactive !== undefined ? ownProps.isInactive : playingIndex + 2 > playables.size,
    onClick: ownProps.onClick,
    iconName: iconName,
    title: typeof ownProps.title !== 'undefined' ? ownProps.title : title
  };
};

var _onClick = function _onClick(playerId) {
  return function (dispatch, getState) {
    var _getState$players$pla = getState().players[playerId],
        playingIndex = _getState$players$pla.playingIndex,
        playables = _getState$players$pla.playables;

    var activeId = playingIndex + 1;

    if (activeId < playables.size) {
      dispatch((0, _players.setPlayingIndex)(playerId, activeId));
    }
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref2) {
  var playerId = _ref2.playerId;

  return {
    onClick: function onClick() {
      if (ownProps.onClick) {
        ownProps.onClick();
      } else {
        dispatch(_onClick(playerId));
      }
    }
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];